/**
 * Privacy Disclaimer.
 * @format
 */

import React from 'react';
import { UseFormRegister, FieldValues, FieldErrors } from 'react-hook-form';
import Checkbox from './checkbox';
import Link from '@base-components/buttons/link';
import { useSafeTranslate } from '@hooks/use-safe-translate';
import { safeLanguageUrlPrefix } from '@services/drupal-services';

type PrivacyDisclaimerProps = {
  register: UseFormRegister<FieldValues>;
  errors?: { [key: string]: FieldErrors };
};

const PrivacyDisclaimer: React.FC<PrivacyDisclaimerProps> = ({
  register,
  errors,
}) => {
  return (
    <div className="form-disclaimer">
      <p className="font-bold">
        <Link
          url={`https://www.varian.com/${safeLanguageUrlPrefix()}node/6420/`}
          linkText={'Please read our privacy notice'}
          openNewWindow={true}
        />
      </p>
      <Checkbox
        fieldProperties={{
          fieldTitle: '',
          fieldName: 'dataPrivacyConsent',
          errorMessage: 'Required field',
          required: true,
          htmlLabel: true,
          list: [
            {
              name: 'consent',
              value: 'consent',
              label: useSafeTranslate(
                'I would like to be contacted for the purpose described above and therefore consent to the storing and processing of my personal data as described in the Privacy Notice.'
              ),
            },
          ],
        }}
        register={register}
        errors={errors}
      />
      <Checkbox
        fieldProperties={{
          fieldTitle: '',
          fieldName: 'Email_Opt_in__c',
          errorMessage: 'Required field',
          required: false,
          htmlLabel: true,
          list: [
            {
              name: 'consent',
              value: 'consent',
              label: useSafeTranslate(
                'I agree to receive communications based on my personal interests and interactions with Siemens Healthineers, as described in the Privacy Notice. I can withdraw my consent any time, with future effect, by unsubscribing.'
              ),
            },
          ],
        }}
        register={register}
        errors={errors}
      />
    </div>
  );
};
export default PrivacyDisclaimer;
